// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2JY21","log":"ModalInventoryLogs_log__3kLjw","date":"ModalInventoryLogs_date__2hKRH","userName":"ModalInventoryLogs_userName__1l_ey"};